import React, { forwardRef, Ref } from "react";
import { Select, SelectProps } from "@heroui/react";

function AppSelectInner<T extends object>(
  props: SelectProps<T>,
  ref: Ref<HTMLSelectElement>
) {
  const baseClass = "rounded-xl data-[focus-visible=true]:outline-0 data-[focus-visible=true]:ring-0 data-[focus-visible=true]:ring-offset-0 data-[hover=true]:bg-[#EBEBEC] data-[focus=true]:bg-[#EBEBEC] data-[selected=true]:bg-[#EBEBEC]";
  const incomingBase = props.listboxProps?.itemClasses?.base;
  const mergedBase = incomingBase ? baseClass + " " + incomingBase : baseClass;

  return (
    <Select
      {...props}
      ref={ref}
      listboxProps={{
        ...props.listboxProps,
        itemClasses: {
          ...props.listboxProps?.itemClasses,
          base: mergedBase,
        },
      }}
    />
  );
}

const AppSelect = forwardRef(AppSelectInner) as <T extends object>(
  props: SelectProps<T> & { ref?: Ref<HTMLSelectElement> }
) => React.ReactElement;

export default AppSelect;

